import { academiaMejiasApi } from "../academiaMejiasApi";


export const getSedesCorreosCRAdmin = async (token: string) => {
    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.get('/admin/sedecorreoscr', {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { ok: true, sedes: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}

export const postSedeCorreosCR = async (token: string, sede: any) => {

    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.post('/admin/sedecorreoscr', sede, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { ok: true, sede: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}

export const putSedeCorreosCR = async (token: string, sede: any) => {

    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.put(`/admin/sedecorreoscr/${sede.id}`, sede, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { ok: true, sede: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}

export const deleteSedeCorreosCR = async (token: string, sedeId: number) => {

    try {
        // Haces la llamada POST a tu API para iniciar sesión
        const { data } = await academiaMejiasApi.delete(`/admin/sedecorreoscr/${sedeId}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { ok: true, sede: data };
    } catch (error: any) {
        // Aquí capturas el error y retornas un objeto indicando el fallo
        console.log(error.response.data);
        return {
            ok: false,
            errorMessage: error.response.data
        };
    }
}